module.exports = __webpack_public_path__ + "img/28.d78989df.png";